import axios from "./axiosInstance";
import {
  CHAT_ASK,
  CHAT_SESSION,
  CHAT_SESSIONS,
} from "./apiEndPoints";
import type {
  IAskResponse,
  IChatSession,
  IChatSessionSummary,
} from "../components/types/chat.types";

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

const ASK_TIMEOUT_MS = 120_000;

export async function askChat(
  question: string,
  sessionId?: string
): Promise<IAskResponse> {
  const res = await axios.post<ApiEnvelope<IAskResponse>>(
    CHAT_ASK,
    sessionId ? { sessionId, question } : { question },
    { timeout: ASK_TIMEOUT_MS }
  );
  return res.data.data;
}

export async function listChatSessions(): Promise<IChatSessionSummary[]> {
  const res = await axios.get<ApiEnvelope<IChatSessionSummary[]>>(CHAT_SESSIONS);
  return res.data.data ?? [];
}

export async function getChatSession(
  sessionId: string
): Promise<IChatSession> {
  const res = await axios.get<ApiEnvelope<IChatSession>>(
    CHAT_SESSION(sessionId)
  );
  return res.data.data;
}

export async function deleteChatSession(sessionId: string): Promise<void> {
  await axios.delete(CHAT_SESSION(sessionId));
}
